export const LOGGED = 'LOGGED'
export const NOT_LOGGED_IN = 'NOT_LOGGED_IN'

export const logged = userData => ({
    type: LOGGED,
    payload: userData
})

export const notLoggedIn = data => ({
    type: NOT_LOGGED_IN,
    payload: null
})


// WEBPACK FOOTER //
// ./src/store/actions/user.js